var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4945 0.0898438H12.2018C11.1945 0.0898438 10.2285 0.479772 9.51626 1.17385C8.80402 1.86792 8.40388 2.80929 8.40388 3.79086C7.39661 3.79086 6.43059 4.18079 5.71834 4.87487C5.00609 5.56894 4.60596 6.51031 4.60596 7.49188V25.997C4.60596 26.9786 5.00609 27.9199 5.71834 28.614C6.43059 29.3081 7.39661 29.698 8.40388 29.698H21.6966C22.7039 29.698 23.6699 29.3081 24.3821 28.614C25.0944 27.9199 25.4945 26.9786 25.4945 25.997C26.5018 25.997 27.4678 25.6071 28.1801 24.913C28.8923 24.2189 29.2924 23.2775 29.2924 22.296V3.79086C29.2924 2.80929 28.8923 1.86792 28.1801 1.17385C27.4678 0.479772 26.5018 0.0898438 25.4945 0.0898438ZM25.4945 24.1465V7.49188C25.4945 6.51031 25.0944 5.56894 24.3821 4.87487C23.6699 4.18079 22.7039 3.79086 21.6966 3.79086H10.3028C10.3028 3.30008 10.5029 2.82939 10.859 2.48236C11.2152 2.13532 11.6982 1.94035 12.2018 1.94035H25.4945C25.9982 1.94035 26.4812 2.13532 26.8373 2.48236C27.1934 2.82939 27.3935 3.30008 27.3935 3.79086V22.296C27.3935 22.7868 27.1934 23.2574 26.8373 23.6045C26.4812 23.9515 25.9982 24.1465 25.4945 24.1465ZM6.50492 7.49188C6.50492 7.0011 6.70499 6.53041 7.06111 6.18338C7.41723 5.83634 7.90024 5.64137 8.40388 5.64137H21.6966C22.2002 5.64137 22.6832 5.83634 23.0394 6.18338C23.3955 6.53041 23.5956 7.0011 23.5956 7.49188V25.997C23.5956 26.4878 23.3955 26.9585 23.0394 27.3055C22.6832 27.6525 22.2002 27.8475 21.6966 27.8475H8.40388C7.90024 27.8475 7.41723 27.6525 7.06111 27.3055C6.70499 26.9585 6.50492 26.4878 6.50492 25.997V7.49188Z",
    fill: "#6A6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.3834,
    height: 29.6082,
    fill: "white",
    transform: "translate(0.808105 0.0898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiFiles);
export default __webpack_public_path__ + "static/media/bi_files.5d09d0f97d3243bb659983a12a4d43c4.svg";
export { ForwardRef as ReactComponent };